import React from "react";
import ReactDOM from "react-dom/client";
// Mono Connect SDK - side-effect import that attaches `window.Connect`.
// Replaces the deprecated <script src="connect.withmono.com/connect.js"> tag
// (Mono retired that CDN domain in 2026). The npm package also correctly
// sets iframe `allow="camera *"` which the CDN version was missing.
import "@mono.co/connect.js";
import "@/utils/clientHeaders";
import { installNativeDownloadInterceptor } from "@/utils/saveFile";
installNativeDownloadInterceptor();
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import ErrorMonitor from './services/errorMonitoring';

ErrorMonitor.init();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA functionality
// This enables offline support and app installation
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('AkountFly is ready for offline use!');
  },
  onUpdate: (registration) => {
    // A new SW is waiting. Activate it immediately and reload so the user
    // picks up the latest bundle without a confirm prompt - older builds
    // here showed `window.confirm(...)`, which was easy to dismiss and
    // stranded users on a stale JS bundle (e.g., the post-iter-702 auth
    // fixes never reached browsers that had `akountfly-v2` SW cached
    // until they hard-refreshed). The new SW already calls skipWaiting()
    // on install, so postMessage is defensive; reload() picks up the new
    // bundle the new SW serves via network-first.
    // eslint-disable-next-line no-console
    console.log('AkountFly: new version detected. Applying and reloading.');
    try {
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
    } catch (_e) { /* noop */ }
    // Small delay so the new SW can claim clients before we reload.
    setTimeout(() => { window.location.reload(); }, 250);
  }
});
